<template>
<div class="page page_hezuo">
    <div class="form_wrap">
        <div class="item flex" @click="kuaiDiPicker = true">
            <div class="item_l">
                <div class="title">快递类型</div>
                <div class="name">
                    <van-field v-model="kuaidi.name" placeholder="请选择类型" readonly />
                </div>
            </div>
            <div class="item_r">选择</div>
        </div>
        <!-- 不包邮 -->
        <div class="item" v-if="kuaidi.type==2">
            <div class="item_l">
                <div class="title">快递费用</div>
                <div class="name">
                    <van-field type="digit" v-model="fare" placeholder="请填写快递费" :border="false" />
                </div>
            </div>
        </div>
        <!-- 满多少包邮 -->
        <div class="item" v-if="kuaidi.type==1">
            <div class="item_l">
                <div class="title">快递费用</div>
                <div class="name flex">
                    <div class="">满</div>
                    <van-field type="digit" v-model="fare_money" placeholder="请填写金额" :border="false" />
                    <div>包邮</div>
                </div>
            </div>
        </div>
    </div>
    <!-- 提交 -->
    <div class="big_btn bottom" @click="tijiao">保存</div>
    <!-- 快递选择弹层 -->
    <van-popup v-model="kuaiDiPicker" position="bottom">
        <van-picker show-toolbar :columns="kuaiDiList" value-key="name" @cancel="kuaiDiPicker = false" @confirm="confrimKuaiDi" />
    </van-popup>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
            publicPath: process.env.BASE_URL,
            token: '',
            kuaidi: { //  对象 包括类型、名字
                type: 0,
                name: '包邮'
            },
            fare: null, // 邮费
            kuaiDiPicker: false, // 快递弹层
            kuaiDiList: [{
                    type: 0,
                    name: '包邮'
                },
                {
                    type: 1,
                    name: '满包邮'
                },
                {
                    type: 2,
                    name: '不包邮'
                }
            ],
            fare_money: null // 满包邮金额
        };
    },
    created: function () {

    },
    mounted: function () {

        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            //修改导航栏样式
            var styleParams = {
                'data': {
                    'naviTitle': '快递设置',
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', styleParams, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            this.token = this.$store.getters.token
        }

    },
    methods: {
        // 确认快递类型
        confrimKuaiDi(value) {
            console.log('value', value)
            this.kuaidi = value
            this.kuaiDiPicker = false
		},
		// 提交快递设置
		tijiao(){
			var params = {
				token: this.token,
				fare_type: this.kuaidi.type
			}
			// 满包邮
			if(this.kuaidi.type == 1){
				if(!this.fare_money){
					this.$toast('请填写满包邮金额')
					return
				}else{
					params.fare_money = this.fare_money
				}
			}
			// 不包邮
			if(this.kuaidi.type == 2){
				if(!this.fare){
					this.$toast('请填写邮费')
					return
				}else{
					params.fare = this.fare
				}
			}
			this.$api.tradesman.fare(params).then(res => {
				if (res.code == 200) {
					this.$toast('设置成功')
					this.$router.back()
				}
			})
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
